import { render, staticRenderFns } from "./GlobalSet.vue?vue&type=template&id=2390671a&scoped=true&"
import script from "./GlobalSet.vue?vue&type=script&lang=js&"
export * from "./GlobalSet.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSet.vue?vue&type=style&index=0&id=2390671a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390671a",
  null
  
)

export default component.exports